import type { ClientUiPublic } from '../api/platformConfig'
import {
  AI_PLATFORM_DUOMI,
  AI_PLATFORM_LINGKEAGI,
  AI_PLATFORM_NOWCODING,
  AI_PLATFORM_SHIYUNAPI,
  normalizeCatalogPlatformId,
} from '../constants/aiPlatforms'
import { platformDisplayLabel } from './platformDisplayLabel'

const PLATFORM_ORDER = [
  AI_PLATFORM_DUOMI,
  AI_PLATFORM_SHIYUNAPI,
  AI_PLATFORM_LINGKEAGI,
  AI_PLATFORM_NOWCODING,
] as const

function sortPlatformKeys(keys: Iterable<string>): string[] {
  const list = [...keys]
  return list.sort((a, b) => {
    const ia = PLATFORM_ORDER.indexOf(a as (typeof PLATFORM_ORDER)[number])
    const ib = PLATFORM_ORDER.indexOf(b as (typeof PLATFORM_ORDER)[number])
    const ra = ia === -1 ? PLATFORM_ORDER.length : ia
    const rb = ib === -1 ? PLATFORM_ORDER.length : ib
    if (ra !== rb) return ra - rb
    return a.localeCompare(b)
  })
}

/** 平台下拉：仅展示当前 clientUi 中至少有一条模型的平台（避免「有平台无模型」） */
export function buildPlatformMenuOptions(clientUi: ClientUiPublic): { value: string; label: string }[] {
  const keys = new Set<string>()
  for (const model of clientUi.imageModels) {
    const n = normalizeCatalogPlatformId(model.platform)
    if (n) keys.add(n)
  }
  return sortPlatformKeys(keys).map((value) => ({
    value,
    label: platformDisplayLabel(value),
  }))
}
